module.exports = __webpack_public_path__ + "static/media/-Utama- Logo GagasMedia - Versi Hitam.a93c9f58.png";